import BaseAPI from '@/services/api/internal/tools/baseAPI';

const UserExchangesAPI = new BaseAPI({});

export default UserExchangesAPI;
